import { List } from "tmaui";
import { AppList } from "../../components/AppList/AppList";

export const AppsPage = () => (
  <List>
    <AppList />
  </List>
);
